import { CategoryLoader } from '@lingvo-news/contracts';
import { Language, TranslationMode, INewsContentService } from '@lingvo-news/contracts';
import { reactive } from 'vue';
import { serviceContainer } from '../service-container';

const vueReactive = <T>(obj: T): T => {
    if (typeof obj === 'object' && obj !== null) {
        return reactive(obj as object) as T;
    }
    return obj;
};

class CategoryStore {
    private loaders: Map<string, CategoryLoader> = new Map();

    private getLoaderKey(sourceLang: Language, targetLang: Language, mode: TranslationMode): string {
        return `${sourceLang}-${targetLang}-${mode}`;
    }

    getLoader(sourceLang: Language, targetLang: Language, mode: TranslationMode): CategoryLoader {
        const key = this.getLoaderKey(sourceLang, targetLang, mode);

        if (!this.loaders.has(key)) {
            const service = serviceContainer.get(INewsContentService);
            const loader = new CategoryLoader(service, sourceLang, targetLang, mode, vueReactive);
            this.loaders.set(key, loader);
        }

        return this.loaders.get(key)!;
    }

    clearCache(sourceLang?: Language, targetLang?: Language, mode?: TranslationMode): void {
        if (sourceLang && targetLang && mode) {
            const key = this.getLoaderKey(sourceLang, targetLang, mode);
            const loader = this.loaders.get(key);
            if (loader) {
                loader.clearCache();
            }
        } else {
            // Clear all loaders
            this.loaders.forEach(loader => loader.clearCache());
        }
    }
}

const categoryStore = new CategoryStore();

export function useCategoryStore() {
    return categoryStore;
}

